<template>
  <v-app class="app" @mousemove="resetIdleTimer" @keydown="resetIdleTimer">
    <modal
      name="idle-modal"
      @before-open="beforeOpen"
      with="50%"
      height="auto"
    >
      <div
        uib-modal-window="modal-window"
        class="modal fade ng-scope ng-isolate-scope show"
        role="dialog"
        aria-labelledby="modal-title"
        aria-describedby="modal-body"
        size="md"
        index="0"
        animate="animate"
        ng-style="{&#39;z-index&#39;: 1050 + $topModalIndex*10, display: &#39;block&#39;}"
        tabindex="-1"
        uib-modal-animation-class="fade"
        modal-in-class="show"
        modal-animation="true"
        style="z-index: 1050; display: block; overflow: auto"
      >
        <div class="modal-dialog dialogModalCustom">
          <div class="modal-content customIdleModal" uib-modal-transclude="">
            <div
              class="
                modal-content
                text-center
                onboarding-modal
                modal-centered
                ng-scope
              "
            >
              <div class="modal-content">

                <div class="modal-header" style="padding-top: 25px;">
                  <h5
                    class="modal-title m-auto"
                    style="text-align: center">
                    <i class="fa fa-power-off" style="color:#6554E0;font-size:22px" aria-hidden="true"></i>
                  </h5>
                 
                </div>
                
                <div class="modal-body pt-0">
                  <div class="d-block text-center">
                    <h6>
                      You're Idle. Do Something!
                      <br/>
                      You'll be logged out in
                      <span style="color:#6554E0">{{ countdown }} </span> second(s).
                    </h6>
                  </div>
                </div>
                
                <div class="modal-footer pt-0" style="padding-bottom: 25px;">
                  <div class="col-lg-12 text-center">
                    <button class="mt-0 btn btn-primary" block @click="stayLoggedIn" data-test-id="stay-logged-in-button" id="stay-logged-in-button">
                      Stay logged in
                    </button>
                  </div>
                </div>

              </div> <!--modal-content -->

            </div>
          </div>
        </div> <!--modal-dialog -->
      </div> <!--modal-window -->
    </modal>

    <router-view />
    <vue-progress-bar />

  </v-app>
</template>

<script>
import ApiManager from "./api/ApiManager";
import Token from "./api/Token";
import log4javascript from 'log4javascript';
import * as Session from "./utils/SessionStore";
import { REMOVE_DEVICE, LOGOUT } from "./store/actionsType";

export default {
  name: "AppCashbook",
  components: {
  },
  created() {
    this.$logger = log4javascript.getLogger("AppCashbook");

    this.$appRoot.AppCyrus = this;
    this.isLoadPage = true;
    // this.isLoadPage = false;
    // this.isDisabled =  false;
    this.setLoadPage();
  },
  data() {
    return {
      username: "",
      avatar: "",
      uid: "",
      btnNot: [],
      btns: [],
      isLoadPage: false,
      isDisabled: false,
      countApi: 0,
      idleTimeout: 1800, // 30 minutes in seconds
      warningTimeout: 120, // 2 minutes warning
      countdown: 0,
      idleTimer: null,
      logoutTimer: null,
      isIdleModalVisible: false,
    };
  },
  beforeMount() {
    // Was `else if (!Vue.prototype.$session.has("data"))` in Vue 2 — that
    // checked vue-session's internal `data` slot. The in-house SessionStore
    // (utils/SessionStore.js) stores the encrypted blob directly under
    // STORAGE_KEY with no wrapper "data" key, so the old fallback unconditionally
    // wiped the session on every page load and re-presented a "session expired"
    // dialog to logged-in users on refresh. The new branch just initialises a
    // fresh blob when there is none on disk; corruption is already swallowed
    // by readBlob().
    if (!Session.exists()) {
      Session.start();
    }
    var now = new Date();
    now.setDate(now.getDate() - 1);
    if (Session.has("dateLogin")) {
      var dateLogin = new Date(Session.get("dateLogin"));
      if (dateLogin <= now) {
        this.$store
          .dispatch(REMOVE_DEVICE, Session.get("Profile").id)
          .then(() => {
            Token.destroySession();
            this.$router.push({
              path: "/login",
            });
          })
          .catch(() => {
            if (this.$global.path != "/updateserver") {
              Token.destroySession();
              this.$router.push({
                path: "/login",
              });
            }
          });
      } else {
        this.checkGetLocation();
      }
    } else {
      this.checkGetLocation();
    }
  },

  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    /// add google map js
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_API_KEY}&libraries=places`;
    script.id = 'google-maps-script';
    document.head.appendChild(script);
    this.startIdleTimer();

    // Add touch event listeners for mobile support
    document.addEventListener('touchstart', this.resetIdleTimer);
  },

  beforeUnmount() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    document.removeEventListener('touchstart', this.resetIdleTimer);
    document.removeEventListener('mousemove', this.resetIdleTimer);
    document.removeEventListener('keydown', this.resetIdleTimer);

    // Remove Google Maps script if it exists
    const script = document.getElementById('google-maps-script');
    if (script) {
      document.head.removeChild(script);
    }
    
    this.clearTimers();
    this.closeModal();
  },

  beforeUpdate() {
    this.isLoadPage = false;
    this.setLoadPage();
  },

  watch: {
    '$route': {
      // Keep the global path in sync with the active route. The right-side help
      // panel in BaseLayout gates its content on `$global.path == '/dashboard'`
      // (etc.); without this the path stays at its initial '/' and every branch
      // renders blank. Pre-migration this lived on the root Vue instance's
      // `$route` watcher — it must stay here now that the root is AppCashbook.
      // `immediate` covers a direct page load where no navigation fires yet.
      immediate: true,
      handler(value) {
        this.$global.path = value.fullPath;
        this.resetIdleTimer();
      }
    }
  },

  methods: {
    setLoadPage() {
      setTimeout(() => {
        if (this.countApi === 0) {
          this.isLoadPage = false;
        } else {
          this.countApi = 0;
          this.isLoadPage = false;
          this.isDisabled = false;
          this.enebleButton();
          this.$Progress.finish();
        }
      }, 1000);
    },
    start() {
      if (!this.isLoadPage && !this.isDisabled) {
        this.$Progress.start();
        this.btns = window.$(".btn");
        this.isDisabled = true;
        for (var i = 0; i < this.btns.length; i++) {
          var btn = this.btns[i];
          
          if (!btn.disabled && !btn.classList.contains("disabled")) {
            btn.disabled = true;
            btn.classList.add("disabled");
          } else {
            if (this.btnNot.indexOf(btn) == -1) {
              this.btnNot.push(btn);
            }
          }
        }
      }
      this.countApi++;
    },
    finish() {
      if (!this.isLoadPage && !this.isDisabled) {
        this.enebleButton();
        this.$Progress.finish();
      } else {
        this.countApi--;
        if (this.countApi == 0) {
          this.isLoadPage = false;
          if (this.isDisabled) {
            this.isDisabled = false;
            this.enebleButton();
            this.$Progress.finish();
          }
        }
      }
    },

    /**
     * Handles the failure scenario.
     * If the page is not loading and the button is not disabled, it enables the button and shows a failure progress indicator.
     * If the page is loading and the button is disabled, it decrements the count of API calls and checks if all API calls have completed.
     * If all API calls have completed, it sets the page loading flag to false.
     * If the button is disabled, it enables the button and shows a failure progress indicator.
     */
    fail() {
      if (!this.isLoadPage && !this.isDisabled) {
        this.enebleButton();
        this.$Progress.fail();
      } else {
        this.countApi--;
        if (this.countApi == 0) {
          this.isLoadPage = false;
          if (this.isDisabled) {
            this.isDisabled = false;
            this.enebleButton();
            this.$Progress.fail();
          }
        }
      }
    },
    
    enebleButton() {
      for (var i = 0; i < this.btns.length; i++) {
        var btn = this.btns[i];
        if (this.btnNot.indexOf(btn) == -1) {
          btn.disabled = false;
          btn.classList.remove("disabled");
        }
      }
    },

    checkGetLocation() {
      if (!Session.has("hasGetLocation") || !Session.get("hasGetLocation")) {
        ApiManager.getLocation();
      }
    },

    // ************************************* START IDLE COUNTDOWN ************************************* //
    isAuthRoute() {
      return this.$global.path === "/login" || this.$global.path === "/register";
    },

    handleVisibilityChange() {
      if (document.hidden) {
        // Tab is hidden, user is likely idle
        // You might want to start the idle timer early
      } else {
        // Tab is visible again, reset timers
        this.resetIdleTimer();
      }
    },
    
    startIdleTimer() {
      this.clearTimers();
      this.closeModal();

      if (this.isAuthRoute()) return;

      this.idleTimer = setTimeout(() => {
        this.showIdleWarning();
      }, this.idleTimeout * 1000);
    },

    showIdleWarning() {
      // already visible
      if (this.isIdleModalVisible || this.isAuthRoute()) return;

      this.countdown = this.warningTimeout;
      this.isIdleModalVisible = true;
      this.$modal.show("idle-modal");
      
      this.clearTimers(); // Ensure no duplicates
      
      this.logoutTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.logoutUser();
        }
      }, 1000);
    },

    resetIdleTimer() {
      if (this.isAuthRoute()) return;
      this.clearTimers();
      this.closeModal();
      this.startIdleTimer();
    },

    clearTimers() {
      if (this.idleTimer) {
        clearTimeout(this.idleTimer);
        this.idleTimer = null;
      }
      if (this.logoutTimer) {
        clearInterval(this.logoutTimer);
        this.logoutTimer = null;
      }
      this.countdown = 0;
    },

    stayLoggedIn() {
      this.resetIdleTimer();
    },

    logoutUser() {
      if (this.isAuthRoute()) return;

      this.clearTimers();
      this.closeModal(); // Explicitly close the modal

      // Store profile ID before clearing session
      const profileId = Session.get("Profile") ? Session.get("Profile").id : null;
  
      
      Session.remove("Username");
      Session.remove("currenCompanyId");
      Session.remove("currenCompanyName");
      Session.remove("currenCompany");
      Session.remove("workHours");
      
      this.$appRoot.AppCyrus.start();
      this.$store
        .dispatch(LOGOUT, Token.getRefreshToken())
        .then(() => {
          if (profileId) {
            this.$store.dispatch(REMOVE_DEVICE, profileId);
          }
          Token.destroySession();
          this.$appRoot.AppCyrus.finish();
          this.$router.push('/login')
        })
        .catch(() => {
          this.$appRoot.AppCyrus.fail();
        });
    },

    closeModal() {
      this.$modal.hide("idle-modal");
      this.isIdleModalVisible = false;
    },

    beforeOpen() {
      // Called when modal is about to open
      this.isIdleModalVisible = true;
    },

  },
};
</script>

<style scoped>
@import url("/assets/fonts/fontawesome-all.min.css");
/* @import '/assets/css/themes.css'; */

.app {
  font-family: "Avenir Next W01", "Proxima Nova W01", "Rubik", -apple-system,
    system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial,
    sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #3e4b5b;
  text-align: center;
  background-color: white;
  margin: 0;
  padding: 0;
}

#nav {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(240, 240, 240);
  height: 50px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.customIdleModal {
  position: absolute;
  top: 0;
  margin-top: -22px;
  z-index: 1800;
}

.dialogModalCustom {
   max-width:550px;
}

</style>
